import { Card, CardContent, Stack, Typography, Chip, Box } from "@mui/material"; // Added Chip, Box
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const CaseHistoryCard = ({ caseData, isCurrent, isCompleted, hasBadData }) => { // Added new props

  const { users } = useSelector((state) => state.user || {});

  const telecallerUsers = useMemo(() => {
    // Here process.env.REACT_APP_TELECALLER is the role id for telecaller
    // so need to filter the users array and return only the users with the role id
    return users.filter((user) => user?.roles?.includes(process.env.REACT_APP_TELECALLER));
  }, [users]);

  const allocatedToUser = useCallback((userId) => {
    return telecallerUsers.find((user) => user.id === userId);
  }, [telecallerUsers]);

  return (
    <Card sx={{
      m: 1,
      border: isCurrent ? '2px solid' : '1px solid', // Highlight if current
      borderColor: isCurrent ? 'primary.main' : 'divider', // Use theme colors
      boxShadow: isCurrent ? 3 : 1 // Add more shadow if current
    }}>
      <CardContent>
        <Stack direction="column" spacing={1}>
          <Typography variant="h6" component="div">
            {caseData.name}
          </Typography>
          <Typography sx={{ mb: 1.5, textWrap: "wrap" }} color="text.secondary">
            {caseData.contact}
          </Typography>
        </Stack>
        <Stack direction={'column'} spacing={1}>
          <Typography variant="body2">
            Status: {caseData.status}
          </Typography>
          <Typography variant="body2">
            Assigned To: {caseData.allocatedToUser?.name}
          </Typography>
          <Typography variant="body2">
            Assigned At: {dayjs(caseData.callDate).format("DD-MM-YYYY")}
          </Typography>
        </Stack>
        {/* Add Chips section */}
        <Box mt={1}>
          <Stack direction="row" spacing={1}>
            {isCompleted && <Chip label="Completed" color="success" size="small" />}
            {hasBadData && <Chip label="Bad Data" color="error" size="small" />}
            {isCurrent && <Chip label="Latest" color="info" size="small" variant="outlined" />} {/* Added Latest chip */}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CaseHistoryCard;
